import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

import ChevronIcon from 'common/shared-ui/src/icons/ChevronIcon';

// Original class: yearSwitcher
const StyledYearSwitcher = styled(Box)(({ theme }) => ({
  border: '1px solid #E4E4EF',
  borderRadius: theme.spacing(4),
  maxWidth: 126,
  height: 40,
}));
// Original class: yearSwitcherButton
const StyledYearSwitcherButton = styled(IconButton)(({ theme }) => ({
  '&[direction="left"]': {
    padding: theme.spacing(0, 4, 0, 2),
  },

  '&[direction="right"]': {
    padding: theme.spacing(0, 2, 0, 4),
  },
}));
const CalendarYearSwitcher = ({ year, handleToggleYear }) => {
  return (
    <StyledYearSwitcher
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        marginBottom: 4,
      }}
    >
      <StyledYearSwitcherButton
        disableRipple
        direction='left'
        onClick={handleToggleYear}
      >
        <ChevronIcon
          direction='left'
          viewBox='0 0 24 24'
          width={24}
          height={24}
        />
      </StyledYearSwitcherButton>
      <Typography variant='h4'>{year}</Typography>
      <StyledYearSwitcherButton
        disableRipple
        direction='right'
        onClick={handleToggleYear}
      >
        <ChevronIcon
          direction='right'
          viewBox='0 0 24 24'
          width={24}
          height={24}
        />
      </StyledYearSwitcherButton>
    </StyledYearSwitcher>
  );
};

export default CalendarYearSwitcher;
